import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { StoreState } from "@store/Store/Reducers";

export default interface StoreApplicationState extends ApplicationState {
    readonly store: StoreState;
}

export const getStoreApplicationState = (state: ApplicationState | StoreApplicationState) => {
    return state as StoreApplicationState;
};
